import { getApiClient, getAxiosInstance } from '../client';
const MEDIA_PREFIX = '/exercises/media/';
/** Typed API functions for exercises */
export const exercisesQueries = {
    /** GET /exercises/:id */
    getById: (id) => getAxiosInstance()
        .get('/exercises/' + id)
        .then((r) => r.data),
    /** GET /exercises/:id/usage — how many programmes/templates reference it */
    getUsage: (id) => getAxiosInstance()
        .get(`/exercises/${id}/usage`)
        .then((r) => r.data),
    /** GET /users/:userId/exercises */
    getByUser: (userId) => getAxiosInstance()
        .get(`/users/${userId}/exercises`)
        .then((r) => r.data),
    /**
     * Absolute URL of a streamable exercise media file (ADR-0038). Media
     * elements load it directly, authenticated by the media-session cookie, so
     * it has to carry the API origin rather than go through axios.
     */
    /**
     * A media element can't send the office or caregiver header, so the Active
     * office and the caregiver entry ride along as `?officeId=` and
     * `?caregiverId=` and count exactly like them (#1822, #1841).
     */
    mediaUrl: (kind, filename) => {
        const url = `${getAxiosInstance().defaults.baseURL}${MEDIA_PREFIX}${kind}/${encodeURIComponent(filename)}`;
        const client = getApiClient();
        const params = new URLSearchParams();
        const officeId = client.getOfficeId();
        const caregiverId = client.getCaregiverId();
        if (officeId)
            params.set('officeId', officeId);
        if (caregiverId)
            params.set('caregiverId', caregiverId);
        const query = params.toString();
        return query ? `${url}?${query}` : url;
    },
    /** True for URLs built by `mediaUrl`: those need `crossorigin="use-credentials"`. */
    isMediaUrl: (url) => url.startsWith(`${getAxiosInstance().defaults.baseURL}${MEDIA_PREFIX}`),
    /** GET /exercises/videos/:filename (blob) */
    getVideoBlob: (filename) => getAxiosInstance()
        .get(`/exercises/videos/${filename}`, { responseType: 'blob' })
        .then((r) => r.data),
    /** GET /exercises/thumbs/:filename (blob) */
    getThumbBlob: (filename) => getAxiosInstance()
        .get(`/exercises/thumbs/${filename}`, { responseType: 'blob' })
        .then((r) => r.data),
    /** GET /exercises/thumbs-from-qr/:filename (blob) */
    getThumbFromQrBlob: (filename, token) => getAxiosInstance()
        .get(`/exercises/thumbs-from-qr/${filename}`, {
        responseType: 'blob',
        headers: { 'X-Therame-Exercise-Upload-Token': token },
    })
        .then((r) => r.data),
    /** GET /exercises/tts/:filename (blob) */
    getTtsBlob: (filename) => getAxiosInstance()
        .get(`/exercises/tts/${filename}`, { responseType: 'blob' })
        .then((r) => r.data),
    /** GET /exercises/uploads/:jobId — poll status of an async upload job (bearer auth) */
    getUploadJobStatus: (jobId) => getAxiosInstance()
        .get(`/exercises/uploads/${jobId}`)
        .then((r) => r.data),
    /** GET /exercises/uploads-from-qr/:jobId — QR variant, authed by upload token header */
    getUploadJobStatusFromQr: (jobId, token) => getAxiosInstance()
        .get(`/exercises/uploads-from-qr/${jobId}`, {
        headers: { 'X-Therame-Exercise-Upload-Token': token },
    })
        .then((r) => r.data),
};
export const exercisesKeys = {
    all: () => ['exercises'],
    detail: (id) => ['exercises', 'detail', id],
    usage: (id) => ['exercises', 'usage', id],
    byUser: (userId) => ['exercises', 'user', userId],
};
//# sourceMappingURL=exercises.queries.js.map